import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faExpandArrowsAlt,
	faCompressArrowsAlt
} from "@fortawesome/free-solid-svg-icons";
import screenfull from "screenfull";

function isRetinaDisplay() {
	if (window.matchMedia) {
		const mq = window.matchMedia(
			"only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 4/2), only screen and (-webkit-min-device-pixel-ratio: 2), only screen  and (min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx)"
		);
		return (mq && mq.matches) || window.devicePixelRatio > 1;
	}
}

library.add(faExpandArrowsAlt);
library.add(faCompressArrowsAlt);

class barraInferior extends React.Component {
	constructor(props) {
		super(props);

		this.changeIcon = this.changeIcon.bind(this);
		const host = window.location.host;
		let alt = "";
		let height = "16";
		if (host.includes("juegosjuegos")) {
			alt = "juegosjuegos";
		} else if (host.includes("jogosjogos")) {
			alt = "jogosjogos";
		} else {
			alt = "pomu";
			height = "22";
		}
		let iconName = "logo_" + alt + "_embed";
		if (isRetinaDisplay()) {
			iconName += "@2x";
		}
		iconName += ".png";

		this.state = {
			fullscreenIcon: "expand-arrows-alt",
			iconName,
			alt,
			height
		};
	}

	changeIcon() {
		this.setState({
			fullscreenIcon: screenfull.isFullscreen
				? "compress-arrows-alt"
				: "expand-arrows-alt"
		});
	}
	componentDidMount() {
		screenfull.on("change", this.changeIcon);
	}
	componentWillUnmount() {
		screenfull.off("change", this.changeIcon);
	}

	render() {
		return (
			<div className="BarraInferior">
				<a
					href={this.props.canonical}
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						src={require(`./${this.state.iconName}`)}
						alt={this.state.alt}
						height={this.state.height}
					/>
				</a>
				<h1>{this.props.title}</h1>
				{screenfull.isEnabled ? (
					<button onClick={() => screenfull.toggle()}>
						<FontAwesomeIcon
							className="icon"
							icon={this.state.fullscreenIcon}
							size="2x"
						/>
					</button>
				) : (
					<div />
				)}
			</div>
		);
	}
}
barraInferior.propTypes = {
	title: PropTypes.string.isRequired,
	canonical: PropTypes.string.isRequired
};
barraInferior.defaultProps = {};

export default barraInferior;
